export var CarouselPeek;
(function (CarouselPeek) {
    /**
     * Resize the number of fully visible cards to take up maximum width
     * Preserves passed in gutter sizes and uses starting width from breakpoints
     */
    CarouselPeek["Resize"] = "Resize";
    /**
     * True to gutter width + item width as passed by consumers of carousel
     */
    CarouselPeek["None"] = "None";
    /**
     * Show a fixed 'peek' when not all cards fit
     */
    CarouselPeek["Fixed"] = "Fixed";
})(CarouselPeek || (CarouselPeek = {}));
//# sourceMappingURL=carouselPeekType.js.map